import Card from '../components/common/Card';
import { Settings, Shield, Database, Users, Bell, Webhook } from 'lucide-react';

export default function AdminSettingsPage() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-display font-bold text-gray-900 dark:text-white">
          Admin Settings
        </h1>
        <p className="text-gray-600 dark:text-gray-300 mt-1">
          Manage system-wide settings and configurations
        </p>
      </div>

      {/* Settings Categories */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card hover className="cursor-pointer">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-primary-100 dark:bg-primary-900/30 rounded-lg flex items-center justify-center">
              <Settings className="w-5 h-5 text-primary-600 dark:text-vivid-cyan-bright" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white">General Settings</h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Configure general system settings and preferences
          </p>
        </Card>

        <Card hover className="cursor-pointer">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-purple-100 dark:bg-vivid-purple-dark/30 rounded-lg flex items-center justify-center">
              <Shield className="w-5 h-5 text-purple-600 dark:text-vivid-purple-light" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white">Security</h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Manage security policies and authentication settings
          </p>
        </Card>

        <Card hover className="cursor-pointer">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-blue-100 dark:bg-vivid-blue-dark/30 rounded-lg flex items-center justify-center">
              <Database className="w-5 h-5 text-blue-600 dark:text-vivid-cyan-bright" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white">Database</h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Configure database connections and backups
          </p>
        </Card>

        <Card hover className="cursor-pointer">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-green-100 dark:bg-vivid-lime-bright/20 rounded-lg flex items-center justify-center">
              <Users className="w-5 h-5 text-green-600 dark:text-vivid-lime-bright" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white">User Management</h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Manage users, roles, and permissions
          </p>
        </Card>

        <Card hover className="cursor-pointer">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-yellow-100 dark:bg-vivid-yellow-bright/20 rounded-lg flex items-center justify-center">
              <Bell className="w-5 h-5 text-yellow-600 dark:text-vivid-yellow-bright" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white">Notifications</h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Configure system notifications and alerts
          </p>
        </Card>

        <Card hover className="cursor-pointer">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-pink-100 dark:bg-vivid-pink-bright/20 rounded-lg flex items-center justify-center">
              <Webhook className="w-5 h-5 text-pink-600 dark:text-vivid-pink-light" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white">Integrations</h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Manage third-party integrations and APIs
          </p>
        </Card>
      </div>

      {/* System Information */}
      <Card>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
          System Information
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">Version</p>
            <p className="text-lg font-medium text-gray-900 dark:text-white">1.0.0</p>
          </div>
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">Environment</p>
            <p className="text-lg font-medium text-gray-900 dark:text-white">Development</p>
          </div>
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">Database Status</p>
            <p className="text-lg font-medium text-green-600 dark:text-vivid-lime-bright">Connected</p>
          </div>
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">API Status</p>
            <p className="text-lg font-medium text-green-600 dark:text-vivid-lime-bright">Operational</p>
          </div>
        </div>
      </Card>
    </div>
  );
}

// Made with Bob
